import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import date from 'quasar/src/utils/date.js';;
var dateFormat = "MM/DD/YYYY";
var shortDateFormat = "M/D/YYYY";
var dateTimeFormat = "MM/DD/YYYY h:mm A";

var DateHelper =
/*#__PURE__*/
function () {
  function DateHelper() {
    _classCallCheck(this, DateHelper);
  }

  _createClass(DateHelper, [{
    key: "checkDate",
    value: function checkDate(val) {
      return /^([0-9]{4}[\/]((0[13-9]|1[012])[\/](0[1-9]|[12][0-9]|30)|(0[13578]|1[02])[\/]31|02[\/](0[1-9]|1[0-9]|2[0-8]))|([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00)[\/]02[\/]29)$/.test(val);
    }
  }, {
    key: "getCurrentDate",
    value: function getCurrentDate() {
      var d = Date.now();
      return date.formatDate(d, dateFormat);
    }
  }, {
    key: "getDateVal",
    value: function getDateVal(d) {
      if (date == null) {
        return this.getCurrentDate();
      }

      d = new Date(d);
      var month = (d.getMonth() + 1).toString().length > 1 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
      var day = d.getDate().toString().length > 1 ? d.getDate() : "0" + d.getDate();
      return d.getFullYear() + "/" + month + "/" + day;
    }
  }, {
    key: "getFriendlyDate",
    value: function getFriendlyDate(d) {
      var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (date == null) {
        return this.getCurrentDate();
      }

      d = new Date(d);
      return date.formatDate(d, short ? shortDateFormat : dateFormat);
    }
  }, {
    key: "getFriendlyDateAllowNull",
    value: function getFriendlyDateAllowNull(d) {
      if (d == null) {
        return null;
      }

      d = new Date(d);
      return date.formatDate(d, dateFormat);
    }
  }, {
    key: "getFriendlyDateTimeAllowNull",
    value: function getFriendlyDateTimeAllowNull(d) {
      if (d == null) {
        return null;
      }

      d = new Date(d);
      return date.formatDate(d, dateTimeFormat);
    }
  }, {
    key: "getLongFriendlyDate",
    value: function getLongFriendlyDate(d) {
      var temp;

      if (d == null) {
        temp = new Date();
      } else {
        temp = new Date(d);
      }

      return date.formatDate(temp, "MMMM DD, YYYY");
    }
  }, {
    key: "getYearVal",
    value: function getYearVal(date) {
      if (date == null) {
        return new Date().getFullYear();
      }

      var d = new Date(date);
      return d.getFullYear();
    }
  }, {
    key: "getMonthOptions",
    value: function getMonthOptions() {
      return [{
        label: "January",
        value: 1
      }, {
        label: "February",
        value: 2
      }, {
        label: "March",
        value: 3
      }, {
        label: "April",
        value: 4
      }, {
        label: "May",
        value: 5
      }, {
        label: "June",
        value: 6
      }, {
        label: "July",
        value: 7
      }, {
        label: "August",
        value: 8
      }, {
        label: "September",
        value: 9
      }, {
        label: "October",
        value: 10
      }, {
        label: "November",
        value: 11
      }, {
        label: "December",
        value: 12
      }];
    }
  }, {
    key: "getMonthOptionsIndexZero",
    value: function getMonthOptionsIndexZero() {
      return [{
        label: "Jan",
        value: 0
      }, {
        label: "Feb",
        value: 1
      }, {
        label: "Mar",
        value: 2
      }, {
        label: "Apr",
        value: 3
      }, {
        label: "May",
        value: 4
      }, {
        label: "Jun",
        value: 5
      }, {
        label: "Jul",
        value: 6
      }, {
        label: "Aug",
        value: 7
      }, {
        label: "Sep",
        value: 8
      }, {
        label: "Oct",
        value: 9
      }, {
        label: "Nov",
        value: 10
      }, {
        label: "Dec",
        value: 11
      }];
    }
  }, {
    key: "addBuisnessDays",
    value: function addBuisnessDays(date, days) {
      var result = new Date(date);

      for (var i = 1; i <= days; i++) {
        result.setDate(result.getDate() + 1);

        if (result.getDay() == 6) {
          result.setDate(result.getDate() + 2);
        } else if (result.getDay() == 0) {
          result.setDate(result.getDate() + 1);
        }
      }

      return result;
    }
  }, {
    key: "getLastDayOfMonth",
    value: function getLastDayOfMonth(year, month) {
      return new Date(year, month, 0);
    }
  }, {
    key: "getDateString",
    value: function getDateString(date) {
      var month = date.substr(5, 2);
      var year = date.substr(0, 4);

      switch (month) {
        case "01":
          month = "Jan";
          break;

        case "02":
          month = "Feb";
          break;

        case "03":
          month = "Mar";
          break;

        case "04":
          month = "Apr";
          break;

        case "05":
          month = "May";
          break;

        case "06":
          month = "Jun";
          break;

        case "07":
          month = "Jul";
          break;

        case "08":
          month = "Aug";
          break;

        case "09":
          month = "Sept";
          break;

        case "10":
          month = "Oct";
          break;

        case "11":
          month = "Nov";
          break;

        case "12":
          month = "Dec";
          break;

        default:
          month = "na";
      }

      return month + "-" + year;
    }
  }, {
    key: "getMonthYearFromString",
    value: function getMonthYearFromString(date) {
      var index = date.indexOf('-');
      var month = date.substring(0, index);
      var year = date.substring(index, index + 5);

      switch (month) {
        case "1":
          month = "Jan";
          break;

        case "2":
          month = "Feb";
          break;

        case "3":
          month = "Mar";
          break;

        case "4":
          month = "Apr";
          break;

        case "5":
          month = "May";
          break;

        case "6":
          month = "Jun";
          break;

        case "7":
          month = "Jul";
          break;

        case "8":
          month = "Aug";
          break;

        case "9":
          month = "Sept";
          break;

        case "10":
          month = "Oct";
          break;

        case "11":
          month = "Nov";
          break;

        case "12":
          month = "Dec";
          break;

        default:
          month = "na";
      }

      return month + year;
    }
  }, {
    key: "removeTime",
    value: function removeTime(stringDate) {
      return stringDate.split(" ")[0];
    }
  }]);

  return DateHelper;
}();

export default new DateHelper();